import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useTheme } from 'styled-components';

import loopLogo from '../assets/svg/loop-optimise-logo-white.svg';

const ThemeAwareLogo = ({ stacked, alt, className }) => {
  const theme = useTheme();
  const [imgError, setImgError] = useState(false);

  // logo path, default to loop logo otherwise (unsure with whitelabel)
  const logoPath = theme.navbar?.logoPath || '/images/loop-optimise-logo-white.svg';

  // Determine which logo to use based on the stacked prop
  const defaultLogo = loopLogo;

  const logoSrc = !imgError && logoPath.startsWith('/') ? process.env.PUBLIC_URL + logoPath : defaultLogo;

  // On error revert to a default if needed? (unsure if there is one for white label)
  const handleError = () => {
    if (!imgError) {
      console.warn(`Failed to load logo from path: ${logoPath}, falling back to default logo`);
      setImgError(true);
    }
  };

  return <img src={logoSrc} alt={alt || 'Company Logo'} className={className} onError={handleError} />;
};

ThemeAwareLogo.propTypes = {
  stacked: PropTypes.bool,
  alt: PropTypes.string,
  className: PropTypes.string,
};

ThemeAwareLogo.defaultProps = {
  stacked: false,
  alt: 'Company Logo',
  className: '',
};

export default ThemeAwareLogo;
